import Salefunnel from './salefunnel'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...Salefunnel
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/salestatus/index.js